import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core, Decorative } from "@faire/design-tokens";
// eslint-disable-next-line import/no-unassigned-import
import "@faire/retailer-visitor-shared/components/slick.css";
import { useInsiderFeatureEligibility } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderFeatureEligibility";
import { useInsiderHelpCenterArticleLink } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderHelpCenterArticleLink";
import { useInsiderMembershipInformation } from "@faire/retailer-visitor-shared/hooks/insider/useInsiderMembershipInformation";
import { CheckoutBenefits } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/__internal__/InsiderHowToUseCardAssets/CheckoutBenefits";
import { DiscoverBrands } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/__internal__/InsiderHowToUseCardAssets/DiscoverBrands";
import { StartSaving } from "@faire/retailer-visitor-shared/views/user/InsiderMarketing/components/InsiderHowToUse/__internal__/InsiderHowToUseCardAssets/StartSaving";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/Arrow";
import { Insider } from "@faire/web--source/slate/icons/InsiderIcon";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useDoActionWhenVisible } from "@faire/web--source/ui/hooks/useDoActionWhenVisible";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Money } from "@faire/web--source/ui/Money";
import { trackInsiderLoggedOutMarketingPageHowToUseSectionView } from "@faire/web-api--source/events/insider/view/loggedOutMarketingPageHowToUseSection";
import { QueryParameters } from "@faire/web-api--source/routes/support/articles/articleId";
import React, { useMemo, useRef } from "react";
import Slider from "react-slick";
import styled from "styled-components";
export var InsiderHowToUse = function() {
    var cardSliderRef = useRef(null);
    var onCardClick = function(index) {
        var _cardSliderRef_current;
        return (_cardSliderRef_current = cardSliderRef.current) === null || _cardSliderRef_current === void 0 ? void 0 : _cardSliderRef_current.slickGoTo(index);
    };
    var ref = useDoActionWhenVisible(function() {
        trackInsiderLoggedOutMarketingPageHowToUseSectionView();
    });
    var cards = useCards();
    return /*#__PURE__*/ _jsx(OuterContainer, {
        ref: ref,
        children: /*#__PURE__*/ _jsxs(Container, {
            children: [
                /*#__PURE__*/ _jsx(Title, {
                    children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "/qoZLB",
                        defaultMessage: [
                            {
                                type: 0,
                                value: "It\u2019s easy to save with Insider"
                            }
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(StyledSlider, {
                    ref: cardSliderRef,
                    variableWidth: true,
                    infinite: true,
                    centerMode: true,
                    dots: true,
                    arrows: true,
                    prevArrow: /*#__PURE__*/ _jsx(PrevArrow, {}),
                    nextArrow: /*#__PURE__*/ _jsx(NextArrow, {}),
                    children: cards.map(function(card, index) {
                        return /*#__PURE__*/ _jsx(Card, {
                            card: card,
                            onClick: onCardClick
                        }, "insider-how-to-use-card-".concat(index));
                    })
                })
            ]
        })
    });
};
var LearnMoreLinkFormatting = function(chunk, helpCenterLink) {
    return /*#__PURE__*/ _jsx(Button, {
        variant: "tertiary",
        linkTo: helpCenterLink,
        target: "_blank",
        children: chunk
    });
};
var Card = function(param) {
    var card = param.card, onClick = param.onClick;
    return /*#__PURE__*/ _jsxs(CardContainer, {
        onClick: function(e) {
            var _e_currentTarget_parentElement_parentElement, _e_currentTarget_parentElement;
            var dataIndex = (_e_currentTarget_parentElement = e.currentTarget.parentElement) === null || _e_currentTarget_parentElement === void 0 ? void 0 : (_e_currentTarget_parentElement_parentElement = _e_currentTarget_parentElement.parentElement) === null || _e_currentTarget_parentElement_parentElement === void 0 ? void 0 : _e_currentTarget_parentElement_parentElement.getAttribute("data-index");
            onClick(Number(dataIndex));
        },
        "data-test-id": "card-".concat(card.titlePrefix),
        children: [
            card.asset,
            /*#__PURE__*/ _jsxs(TitlesContainer, {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: {
                            mobileAndAbove: "subheadingSansMedium",
                            desktopAndAbove: "sectionHeaderSansMedium"
                        },
                        children: card.titlePrefix
                    }),
                    /*#__PURE__*/ _jsxs(TextContainer, {
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: {
                                    mobileAndAbove: "subheadingSansMedium",
                                    desktopAndAbove: "sectionHeaderSansMedium"
                                },
                                children: card.title
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "paragraphSansRegular",
                                children: card.subtitle
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var OuterContainer = styled(Column).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-cab435e0-0"
})([
    "background-color:",
    ";padding:",
    ";",
    "{padding-top:",
    ";}"
], Decorative.shade.teal, getSpacing("5x", 0, "8x"), responsiveMediaQueries.desktopAndAbove, getSpacing("10x"));
var Title = styled(Typography).attrs({
    variant: {
        mobileAndAbove: "displaySSerifRegular",
        tabletAndAbove: "displayMSerifRegular"
    },
    color: Core.text.inverse,
    align: "center"
}).withConfig({
    componentId: "sc-cab435e0-1"
})([
    "&&&{padding:",
    ";}"
], getSpacing(0, "5x"));
var TitlesContainer = styled(Row).attrs({
    gap: {
        mobileAndAbove: 20,
        desktopAndAbove: 4
    }
}).withConfig({
    componentId: "sc-cab435e0-2"
})([
    "width:100%;background-color:white;border-top:1px solid ",
    ";padding:32px 20px;border-radius:0px 0px 4px 4px;height:239px;",
    "{height:234px;padding:39px 36px;}"
], Core.border.muted, responsiveMediaQueries.desktopAndAbove);
var TextContainer = styled(Column).attrs({
    gap: {
        mobileAndAbove: 3,
        desktopAndAbove: 13
    }
}).withConfig({
    componentId: "sc-cab435e0-3"
})([
    ""
]);
var CardContainer = styled(Column).withConfig({
    componentId: "sc-cab435e0-4"
})([
    "position:relative;margin:0 4.5px;z-index:1;opacity:30%;transition:opacity 0.3s ease-in-out;&:hover{cursor:pointer;}background-color:",
    ";border:1px solid ",
    ';filter:"drop-shadow(0 4px 8px rgba(0, 0, 0, 0.15))";border-radius:4px;width:330px;height:499px;',
    "{margin:",
    ";width:503px;height:630px;}"
], Core.surface.muted, Core.border.muted, responsiveMediaQueries.desktopAndAbove, getSpacing(0, "3x"));
var Container = styled(Column).attrs({
    gap: {
        mobileAndAbove: "5x",
        desktopAndAbove: "10x"
    }
}).withConfig({
    componentId: "sc-cab435e0-5"
})([
    "width:100%;"
]);
var PrevArrow = function(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ _jsx(SlideButton, {
        "data-test-id": "left-arrow",
        onClick: onClick,
        className: "arrow ".concat(className),
        children: /*#__PURE__*/ _jsx(Arrow, {
            width: "16px",
            height: "16px",
            direction: "left",
            color: Core.icon.default
        })
    });
};
var NextArrow = function(props) {
    var className = props.className, onClick = props.onClick;
    return /*#__PURE__*/ _jsx(SlideButton, {
        "data-test-id": "right-arrow",
        onClick: onClick,
        className: "arrow ".concat(className),
        children: /*#__PURE__*/ _jsx(Arrow, {
            width: "16px",
            height: "16px",
            direction: "right",
            color: Core.icon.default
        })
    });
};
var SlideButton = styled.div.withConfig({
    componentId: "sc-cab435e0-6"
})([
    "width:35px;height:35px;cursor:pointer;border-radius:50%;border:1px solid ",
    ";background-color:",
    ";filter:drop-shadow(0px 2px 6px rgba(0,0,0,0.1));padding:",
    ";align-items:center;&:hover{background-color:",
    ";border-color:",
    ";}"
], Core.border.muted, Core.surface.inverse, getSpacing("1x"), Core.surface.inverse, Core.border.muted);
var StyledSlider = styled(Slider).withConfig({
    componentId: "sc-cab435e0-7"
})([
    ".slick-list{height:499px;",
    "{height:630px;}}.slick-dots{margin-top:40px;}.slick-dots li,.slick-dots li button{width:18px;}.slick-dots li button:before{font-size:35px;color:",
    ";}.slick-dots li.slick-active button:before{color:",
    ";}.slick-prev{left:calc(50% - 270px);}.slick-next{right:calc(50% - 270px);}.slick-prev,.slick-next{display:none !important;",
    "{display:flex !important;z-index:1;}}.slick-active{",
    "{filter:unset;opacity:100%;}}"
], responsiveMediaQueries.desktopAndAbove, Decorative.tint.blue, Core.text.inverse, responsiveMediaQueries.desktopAndAbove, CardContainer);
var useCards = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var hasFreeDutyAdvertising = useInsiderFeatureEligibility().hasFreeDutyAdvertising;
    var helpCenterLink = useInsiderHelpCenterArticleLink(QueryParameters.build({
        section: hasFreeDutyAdvertising ? "4" : "2"
    }));
    var cards = useMemo(function() {
        return [
            {
                asset: /*#__PURE__*/ _jsx(DiscoverBrands, {}),
                titlePrefix: "1.",
                title: strictLocalize({
                    id: "J4krFA",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Discover brands with Insider benefits"
                        }
                    ]
                }),
                subtitle: /*#__PURE__*/ _jsx(DiscoverBrandsSubtitle, {})
            },
            {
                asset: /*#__PURE__*/ _jsx(CheckoutBenefits, {}),
                titlePrefix: "2.",
                title: strictLocalize({
                    id: "RmeTYd",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "See your benefits applied at checkout"
                        }
                    ]
                }),
                subtitle: hasFreeDutyAdvertising ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "k9YQk3",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Free shipping is automatically applied at checkout when you join Insider. Import duties are either covered at checkout, or reimbursed by Faire on your invoice. "
                        },
                        {
                            type: 8,
                            value: "LearnMoreLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Learn more"
                                }
                            ]
                        }
                    ],
                    values: {
                        LearnMoreLinkFormatting: function(chunks) {
                            return LearnMoreLinkFormatting(chunks, helpCenterLink);
                        }
                    }
                }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "6SmYp/",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Free shipping is automatically applied at checkout when you join Insider. "
                        },
                        {
                            type: 8,
                            value: "LearnMoreLinkFormatting",
                            children: [
                                {
                                    type: 0,
                                    value: "Learn more"
                                }
                            ]
                        }
                    ],
                    values: {
                        LearnMoreLinkFormatting: function(chunks) {
                            return LearnMoreLinkFormatting(chunks, helpCenterLink);
                        }
                    }
                })
            },
            {
                asset: /*#__PURE__*/ _jsx(StartSaving, {}),
                titlePrefix: "3.",
                title: strictLocalize({
                    id: "FWEOYL",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Start saving"
                        }
                    ]
                }),
                subtitle: hasFreeDutyAdvertising ? strictLocalize({
                    id: "VS7IHM",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Whenever you shop a brand with Insider benefits, you'll save big on shipping and import duties. See how much you\u2019ve saved by visiting your Account Settings."
                        }
                    ]
                }) : strictLocalize({
                    id: "qlC5nh",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Whenever you shop a brand with Insider benefits, you'll save big on shipping. See how much you\u2019ve saved by visiting your Account Settings."
                        }
                    ]
                })
            }
        ];
    }, [
        hasFreeDutyAdvertising,
        helpCenterLink,
        strictLocalize
    ]);
    return cards;
};
var DiscoverBrandsSubtitle = function() {
    var _useInsiderFeatureEligibility = useInsiderFeatureEligibility(), hasFreeDutyAdvertising = _useInsiderFeatureEligibility.hasFreeDutyAdvertising, ignoreThresholdAdvertising = _useInsiderFeatureEligibility.ignoreThresholdAdvertising;
    var _useInsiderMembershipInformation = useInsiderMembershipInformation(), _useInsiderMembershipInformation_thresholds = _useInsiderMembershipInformation.thresholds, thresholdValue = _useInsiderMembershipInformation_thresholds.threshold1;
    if (thresholdValue && !ignoreThresholdAdvertising) {
        return /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "KE9aOd",
            defaultMessage: [
                {
                    type: 0,
                    value: "The Insider key "
                },
                {
                    type: 1,
                    value: "insiderIconToken"
                },
                {
                    type: 0,
                    value: " designates brands with free shipping and import duties. Some require an order of "
                },
                {
                    type: 1,
                    value: "freeShippingThresholdMoney"
                },
                {
                    type: 0,
                    value: " to qualify."
                }
            ],
            values: {
                insiderIconToken: /*#__PURE__*/ _jsx(Insider, {
                    viewBox: "0 0 14 12",
                    small: true
                }),
                freeShippingThresholdMoney: /*#__PURE__*/ _jsx(Money, {
                    money: thresholdValue,
                    omitCentsIfZero: true
                })
            }
        });
    }
    return hasFreeDutyAdvertising ? /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "XdMVDn",
        defaultMessage: [
            {
                type: 0,
                value: "As you're browsing on Faire, look for the Insider key icon "
            },
            {
                type: 1,
                value: "insiderIconFullyTranslatedSentence"
            },
            {
                type: 0,
                value: " or filter to find brands with free shipping and import duties."
            }
        ],
        values: {
            insiderIconFullyTranslatedSentence: /*#__PURE__*/ _jsx(Insider, {
                viewBox: "0 0 14 12",
                small: true
            })
        }
    }) : /*#__PURE__*/ _jsx(StrictLocalMsg, {
        id: "2C7jeT",
        defaultMessage: [
            {
                type: 0,
                value: "As you're browsing on Faire, look for the Insider key icon "
            },
            {
                type: 1,
                value: "insiderIconFullyTranslatedSentence"
            },
            {
                type: 0,
                value: " or filter to find brands with free shipping."
            }
        ],
        values: {
            insiderIconFullyTranslatedSentence: /*#__PURE__*/ _jsx(Insider, {
                viewBox: "0 0 14 12",
                small: true
            })
        }
    });
};
